export const css = {
    oneaction: '_10t1WvnQ',
    ' _key': 'apic-theme/apic/quiz-widgets/discussion'
};
export default css;
